import {
  shape,
  number,
  string
} from 'prop-types';

export default shape({
  id: number.isRequired,
  name: string.isRequired
});



// WEBPACK FOOTER //
// ./src/utils/shapes/Bike.js